module.exports = __webpack_public_path__ + "img/jobs_example3.f5c2129b.jpg";